import React, {FC} from "react";
import {useSelector} from "react-redux";
import "./ToolbarView.scss";
import {AppState} from "../../AppState";
import {MobileToolbar} from "./MobileToolbar";
import {DesktopToolbar} from "./DesktopToolbar";
import {SystemActions} from "../../actions/SystemActions";
import {isTearOffWindow} from "../../App";
import classNames from "classnames";
import {useAppDispatch} from "../../hooks/ReduxHooks";

export const ToolbarView: FC = () => {

    const isMobile = useSelector(({system}: AppState) => system.isMobile);

    const dispatch = useAppDispatch();

    if (isTearOffWindow) {
        return null;
    }

    const onHideToolbarMenu = () => dispatch(SystemActions.showToolbarMenu(false));
    
    return (
        <div className={classNames("main-toolbar", {"mobile": isMobile})}
             key="toolbar"
             onClick={onHideToolbarMenu}>
            {isMobile ? <MobileToolbar/> : <DesktopToolbar/>}
        </div>
    );
};
